import type { IterableLike } from "../types/IterableLike"
import { to_array } from "./to_array"

/**
 * Gets last element of iterable.
 *
 * @param any - Array, object, or primitive
 * @returns Last element
 *
 * @example
 * ```ts
 * import { last } from "@pdfking/rfunc"
 *
 * last([1, 2, 3]) // 3
 * last({ a: 1, b: 2 }) // 2
 * last(5) // 5
 * ```
 */
export const last = <T>(iterable: IterableLike<T>): T | undefined => {
  const arr = to_array(iterable)
  return arr[arr.length - 1]
}
